/** Routen rund um den Loadout Creator. */
export const LOADOUT_CREATOR_ROUTE = '/loadout-creator';
export const LOADOUT_TEST_ACCESS_ROUTE = '/loadout/access';
